import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class Html5VideoComponent {
    constructor() {
        this.playerVars = {};
        this.playsinline = true;
        // tslint:disable: no-output-rename
        // tslint:disable: no-output-on-prefix
        this.load = new EventEmitter();
        this.ready = new EventEmitter();
        this.onPlay = new EventEmitter();
        this.onPause = new EventEmitter();
        this.playerDefaults = {
            autoplay: false,
            controls: true,
            muted: false,
            loop: false,
        };
        this.isLoaded = false;
        this.stateClassName = 'is--unloaded';
    }
    log(e) {
        console.log(e);
    }
    async ngOnInit() {
        this.playerVars = Object.assign(this.playerDefaults, this.playerVars);
    }
    ngOnChanges(changes) {
        const videoEl = this.ref.nativeElement;
        // Set isLoaded true when video is ready to play
        this.isLoaded = videoEl.readyState === 4;
        videoEl.muted = this.playerVars.muted || false;
        if (!this.playerVars.autoplay) {
            !this.ref.nativeElement.paused
                ? this.ref.nativeElement.play()
                : this.ref.nativeElement.pause();
        }
    }
    play() {
        this.ref.nativeElement.play();
    }
    pause() {
        this.ref.nativeElement.pause();
    }
    togglePlay() {
        const videoEl = this.ref.nativeElement;
        if (videoEl.paused) {
            this.play();
        }
        else {
            this.pause();
        }
    }
    _volumeChange(event) {
        const videoEl = this.ref.nativeElement;
        this.playerVars = Object.assign(this.playerVars, { muted: videoEl.muted });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: Html5VideoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.2", type: Html5VideoComponent, selector: "fstr-html5-video", inputs: { src: "src", playerVars: "playerVars", poster: "poster", playsinline: "playsinline" }, outputs: { load: "load", ready: "ready", onPlay: "play", onPause: "pause" }, viewQueries: [{ propertyName: "ref", first: true, predicate: ["videoBg"], descendants: true, static: true }], exportAs: ["fstrHtml5Video"], usesOnChanges: true, ngImport: i0, template: "<div class=\"fstr-html5-video__container {{ stateClassName }}\">\n  <video\n    class=\"fstr-html5-video__container__video\"\n    [loop]=\"playerVars.loop\"\n    [muted]=\"playerVars.muted\"\n    [autoplay]=\"playerVars.autoplay\"\n    [poster]=\"poster\"\n    [controls]=\"playerVars.controls\"\n    [src]=\"src\"\n    playsinline=\"playsinline\"\n    (load)=\"load.emit($event)\"\n    (play)=\"onPlay.emit($event)\"\n    (pause)=\"onPause.emit($event)\"\n    (canplay)=\"ready.emit($event)\"\n    (volumechange)=\"_volumeChange($event)\"\n    [class.is--loaded]=\"isLoaded\"\n    #videoBg\n  ></video>\n</div>\n", styles: [".fstr-html5-video__container{width:100%;height:0;overflow:hidden;padding-bottom:56.25%;position:relative;display:block}::ng-deep .fstr-html5-video__container__video{width:100%;height:100%;position:absolute;inset:0}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: Html5VideoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fstr-html5-video', changeDetection: ChangeDetectionStrategy.OnPush, exportAs: 'fstrHtml5Video', template: "<div class=\"fstr-html5-video__container {{ stateClassName }}\">\n  <video\n    class=\"fstr-html5-video__container__video\"\n    [loop]=\"playerVars.loop\"\n    [muted]=\"playerVars.muted\"\n    [autoplay]=\"playerVars.autoplay\"\n    [poster]=\"poster\"\n    [controls]=\"playerVars.controls\"\n    [src]=\"src\"\n    playsinline=\"playsinline\"\n    (load)=\"load.emit($event)\"\n    (play)=\"onPlay.emit($event)\"\n    (pause)=\"onPause.emit($event)\"\n    (canplay)=\"ready.emit($event)\"\n    (volumechange)=\"_volumeChange($event)\"\n    [class.is--loaded]=\"isLoaded\"\n    #videoBg\n  ></video>\n</div>\n", styles: [".fstr-html5-video__container{width:100%;height:0;overflow:hidden;padding-bottom:56.25%;position:relative;display:block}::ng-deep .fstr-html5-video__container__video{width:100%;height:100%;position:absolute;inset:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { src: [{
                type: Input
            }], playerVars: [{
                type: Input
            }], poster: [{
                type: Input
            }], playsinline: [{
                type: Input
            }], load: [{
                type: Output
            }], ready: [{
                type: Output
            }], onPlay: [{
                type: Output,
                args: ['play']
            }], onPause: [{
                type: Output,
                args: ['pause']
            }], ref: [{
                type: ViewChild,
                args: ['videoBg', { static: true }]
            }] } });

class Html5VideoPlayerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: Html5VideoPlayerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.2", ngImport: i0, type: Html5VideoPlayerModule, declarations: [Html5VideoComponent], imports: [CommonModule], exports: [Html5VideoComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: Html5VideoPlayerModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: Html5VideoPlayerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [Html5VideoComponent],
                    imports: [CommonModule],
                    exports: [Html5VideoComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { Html5VideoComponent, Html5VideoPlayerModule };
